import { useMemo } from 'react';
import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { SMSNumberV1 } from '@frontend/api-sms-number';

export type UseCareCreditSmsNumberProps = {
  person: Person | undefined;
  locationId: string | undefined;
};
export const useCareCreditSmsNumber = ({ person, locationId }: UseCareCreditSmsNumberProps) => {
  const { validPhones } = SMSNumberV1.Hooks.usePersonSMSNumbersValidity({
    personId: person?.personId ?? '',
    person,
    groupIds: locationId ? [locationId] : [],
  });

  const firstValidPhoneNumber = useMemo(() => {
    return validPhones[0]?.number;
  }, [JSON.stringify(validPhones)]);

  return {
    firstValidPhoneNumber,
  };
};
